export { IIcoTransportable as default } from 'transports/types/IIcoTransportable';
